export default __webpack_public_path__ + "static/media/36.59ec987e.jpeg";